<script>
import {secondsToTimeString} from "../../../../../utils/time";

export default {
    name: "duration-type-setting",
    props: {
        elementDurationDisabled: Boolean,
        durationElement: String,
        disabled: Boolean,
        value: {}
    },
    computed: {
        label() {
            return Lang.langGet("Duration");
        },
        items() {
            const suffix = this.durationElement === '?' ? '' : `(${secondsToTimeString(this.durationElement)})` ;
            return [
                {value: 2, text: Lang.langGet("Element duration") + suffix, disabled: this.elementDurationDisabled},
                {value: 1, text: Lang.langGet("Standard duration")},
                {value: 0, text: Lang.langGet("Free duration")}
            ]
        }
    }
}
</script>

<template>
    <v-select-custom
        :value="value"
        @input="$emit('input', $event)"
        :label="label"
        :disabled="disabled"
        :items="items"
    />
</template>
